import { render, staticRenderFns } from "./WKSMenSuoList.vue?vue&type=template&id=af15a9aa&scoped=true"
import script from "./WKSMenSuoList.vue?vue&type=script&lang=js"
export * from "./WKSMenSuoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af15a9aa",
  null
  
)

export default component.exports